<template>
  <div>
    <div class="process">
      <div v-bind:style="{width: percent+'%'}"></div>
    </div>
  </div>
</template>
<script>
export default {
    props:['percent'],
  data() {
    return {
      //health: 60,
      eable: false
    };
  },
  methods: {
    
  }
};
</script>
<style lang="">
.process {
  width: 100%;
  height: 10px;
  margin-top:10px;
  background: #d6d6d6;
}

.process div {
  height: 10px;
  background: #24bcf4;
}

.bu {
  width: 250px;
  margin: 20px auto;
}

.bu button {
  margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/percent.vue